<template>
	<div>
		<img  class="imgtop" src="https://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/2020122310043322b664.jpg"/>
		<div class="roww center_center" style="margin-top: 30px;margin-bottom: 30px;">
			<img style="width: 500px;" src="https://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/202109231221501c6131.jpg" />
		</div>
	</div>
</template>

<script>

	export default {
		name: 'ComponentName', // 组件的名称
		components: {
			
		},

		data() {
			return {
				
			}
		},

		props: {
			// 组件的属性
		},

		computed: {
			// 组件的计算属性
		},

		methods: {

		},

		mounted() {
			// 组件挂载后的操作
		},

	}
</script>

<style>
	@import url(zixunhezuo.css);
</style>